const LOCAL_API_ORIGIN = 'http://127.0.0.1:5001';

const isDevelopment = process.env.NODE_ENV === 'development';

function normalizeApiOrigin(origin) {
  return String(origin || '').replace(/\/+$/, '');
}

export const API_ORIGIN = isDevelopment
  ? normalizeApiOrigin(process.env.REACT_APP_API_ORIGIN_DEV || LOCAL_API_ORIGIN)
  : normalizeApiOrigin(process.env.REACT_APP_API_ORIGIN || '');
